export default __webpack_public_path__ + "static/media/acme-logo.4a2fed39.jpg";